const getCookie = (cookieName) => {
    const cookie = {};
    document.cookie.split(";").forEach((el) => {
        const [key, value] = el.split("=");
        cookie[key.trim()] = value;
    });
    return cookie[cookieName];
};

const deleteCookie = (cookieName) => {
    // Delete cookie by setting multiple variations
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    document.cookie = `${cookieName}=; max-age=0; path=/`;
    
    // Also try with domain
    const domain = window.location.hostname;
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`;
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${domain}`;
};

export { getCookie, deleteCookie };